export default __webpack_public_path__ + "static/media/icon__6.418a6483.svg";